import React from 'react';
import PropTypes from 'prop-types';
import cn from "../../../utils/cn";
import Icon from "../Icon/Icon";
import MoreOrLessButton from "../MoreOrLessButton/MoreOrLessButton";
import phones from "../../utils/Phones";
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const CompactPhoneNumbers = _ref => {
  let {
    phone_numbers = [],
    max_numbers_collapsed = 3
  } = _ref;
  if (!phone_numbers.length) {
    return null;
  }
  const rootClasses = cn('relative mb-5 leading-5');
  const phoneNumbers = phones.sortPhoneNumbers(phone_numbers, ['mobile', 'home', 'work', 'fax', 'unknown']).filter(number => Boolean(number.phone_number));
  const PhoneNumbersList = _ref2 => {
    let {
      showMore
    } = _ref2;
    return /*#__PURE__*/_jsx(_Fragment, {
      children: phoneNumbers.map((phoneNumber, index) => {
        const {
          extension = '',
          phone_type = '',
          phone_number = '',
          is_primary = false
        } = phoneNumber;
        if (!showMore && index + 1 > max_numbers_collapsed || !phone_number) {
          return null;
        }
        return /*#__PURE__*/_jsxs("div", {
          className: "pl-8 mt-1 leading-5 text-sm text-text-blue normal-case font-regular-font",
          children: [phone_type && /*#__PURE__*/_jsxs("span", {
            className: "capitalize",
            "data-test-element": `phone-numbers_type_${index}`,
            children: [phone_type, ":", ' ']
          }), /*#__PURE__*/_jsx("a", {
            href: phones.getTelLink(phoneNumber),
            target: "_blank",
            tabIndex: 0,
            rel: "noopener noreferrer",
            "data-test-element": `phone-numbers_link_${index}`,
            children: /*#__PURE__*/_jsx("span", {
              "data-test-element": `phone-numbers_number_${index}`,
              children: `${phones.formatPhoneNumber(phone_number)}${extension ? ` ${extension}` : ''}`
            })
          }), is_primary && /*#__PURE__*/_jsxs("span", {
            className: "italic",
            "data-test-element": `phone-numbers_primary_${index}`,
            children: [' ', "Primary"]
          })]
        }, `phone-${phone_number}`);
      })
    });
  };
  PhoneNumbersList.propTypes = {
    showMore: PropTypes.bool.isRequired
  };
  return /*#__PURE__*/_jsxs("div", {
    className: rootClasses,
    children: [/*#__PURE__*/_jsx("div", {
      className: "absolute top-0 left-0",
      children: /*#__PURE__*/_jsx(Icon, {
        size: 20,
        icon: "Phone",
        color: "action-blue"
      })
    }), phoneNumbers.length > max_numbers_collapsed ? /*#__PURE__*/_jsx(MoreOrLessButton, {
      moreText: "See more",
      lessText: "See less",
      className: "mt-1 py-2",
      omitDefaultStyles: true,
      children: /*#__PURE__*/_jsx(PhoneNumbersList, {})
    }) : /*#__PURE__*/_jsx(PhoneNumbersList, {})]
  });
};
CompactPhoneNumbers.propTypes = {
  phone_numbers: PropTypes.arrayOf(PropTypes.shape({
    phone_type: PropTypes.string,
    phone_number: PropTypes.string,
    country_code: PropTypes.string,
    is_primary: PropTypes.bool,
    extension: PropTypes.string
  })),
  max_numbers_collapsed: PropTypes.number
};
export default CompactPhoneNumbers;
//# sourceMappingURL=CompactPhoneNumbers.js.map